<div class="participantcontainer">
    <div class="participantvideodiv">
        <video class="participantvideo localparticipant" playsinline autoplay muted #video></video>
        <audio #audio></audio>
        <!-- <div>Volume level: {{volumeLevel}}</div> -->
        <!-- <input  type="range" #audioVolume [attr.value]="this.volumeLevel" class="volume-meter w-100" disabled max="100"> -->
        <div class="videosettingsdiv">
            <button [ngClass]="['enableaudiobutton', 'fas', audioEnabled ? 'null' : 'bg-grey', audioEnabled ? 'fa-microphone' : 'fa-microphone-slash']" (click)="toggleAudioEnabled()"></button>
            <button [ngClass]="['enablevideobutton', 'fas', videoEnabled ? 'null' : 'bg-grey', videoEnabled ? 'fa-video' : 'fa-video-slash']" (click)="toggleVideoEnabled()"></button>
        </div>
        <div class="volume-meter" #volumeMeter></div>
    </div>
    <!-- <div class="volume-meter-background" [hidden]="this.volumeLevel === undefined"> -->
        
    <!-- </div> -->
</div>


